import { useMemo } from "react";
import { useSelector } from "react-redux";
import { GPicker } from "../../../../../GPicker";
import MondayButton from "../../../../../commonComponents/MondayButton/MondayButton";

/**
 *
 * @param {Array} uploadedFiles Array of the uploaded files.
 * @param {Function} onDelete On Delete button click callback function.
 * @param {Function} onPickerSuccess On file upload callback function.
 * @param {Function} accessToken API access token.
 * @param {Function} folderId Id of the target folder.
 */

const ProblemsDocUploader = ({
  onPickerSuccess = () => {},
  disabled = false,
  folderId,
}) => {
  const { accessToken } = useSelector((state) => state.accessToken);
  const { hotCredentials } = useSelector((state) => state.hotCredentials);

  const developerKey = useMemo(() => {
    if (!hotCredentials?.length) return null;

    const idx = hotCredentials.findIndex(
      (credential) => credential.credentialId === "2"
    );
    if (idx === -1) return null;

    return hotCredentials[idx].credentialValue;
  }, [hotCredentials]);

  return (
    <>
      <div className="uploadSection">
        <GPicker
          token={accessToken}
          onAuthenticate={() => {}}
          createPicker={(google, oauthToken) => {
            const uploadView = new google.picker.DocsUploadView()
              .setIncludeFolders(false)
              .setParent(folderId);

            const picker = new window.google.picker.PickerBuilder()
              .enableFeature(google.picker.Feature.SIMPLE_UPLOAD_ENABLED)
              .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
              .enableFeature(google.picker.Feature.MINE_ONLY)
              .enableFeature(google.picker.Feature.NAV_HIDDEN)
              .addView(uploadView)
              .setOAuthToken(oauthToken)
              .setDeveloperKey(developerKey)
              .setCallback(async (data) => {
                if (
                  data.action === google.picker.Action.PICKED &&
                  !!data.docs.length
                ) {
                  onPickerSuccess({
                    uploadedFiles: data.docs,
                  });
                }
              });
            picker.build().setVisible(true);
          }}
        >
          <MondayButton
            {...{
              className: "uploaderProblemsButton mondayButtonBlue",
              disabled: disabled || !folderId || !accessToken,
              hasIcon: false,
            }}
          >
            Ngarkoni dokumente
          </MondayButton>
        </GPicker>
      </div>
    </>
  );
};

export default ProblemsDocUploader;
